module.exports = __webpack_public_path__ + "static/media/image-card-5.2488b141.png";